<!-- version 4.3.0 2026-03-31 -->
<span
  class="_sr-only"
  i18n="{{settings.label}}@@{{settings.id}}"
  id="label-{{settings.id}}"
  [innerHtml]="(settings.label || 'Menu') + (settings.selected?.name ? ', ' + settings.selected?.name + ' Selected' : '')"
></span>
<div
  [attr.aria-labelledby]="'label-' + settings.id"
  class="axis-menu-container {{settings.templateClasses ? ' ' : null}}{{settings.templateClasses}} {{settings.columns>1 ? 'column-' + settings.columns : null}}"
  [class.align-right]="settings.align==='right'"
  [class.arrow-none]="!settings.arrowIcon"
  [class.axis-menu-hover]="settings.menuVisible"
  [class.axis-menu-ul]="settings.menuVisible"
  [class.has-axis-multicolumn]="settings.columns>1"
  [class.nowrap]="!settings.wrap"
  [class.openMenu]="settings.menuVisible"
  [class.outline-none]="settings.outline==='none'"
  [class.width-full]="settings.width==='full'"
  id="{{settings.id}}"
  (mouseleave)="closeFlyout('mouseleave')"
>
  <button
    aria-haspopup="menu"
    [attr.aria-labelledby]="'label-' + settings.id"
    [attr.aria-expanded]="settings.menuVisible"
    axis-button
    class="axis-menu-btn kind-{{buttonDataKind}}"
    (click)="openMenu();stopPropagation($event)"
    id="button-{{settings.id}}"
    (keydown.arrowdown)="goMenu($event)"
    (keydown.enter)="focusActiveOption(settings)"
    (keydown.escape)="focusOption($event)"
    (keydown.shift.tab)="focusOption($event)"
    (keydown.space)="focusActiveOption(settings)"
    (keydown.tab)="focusOption($event)"
    (mouseenter)="focusActiveOption(settings)"
  >
    @if (headingIcon) {
    <axis-icon
      class="{{settings['headingIcon']?.color ? '_text-' + settings['headingIcon']?.color : null}} {{settings['headingIcon']?.size ? 'size-' + settings['headingIcon']?.size : null}}"
      [font]="settings['headingIcon'].font"
      [icon]="settings['headingIcon'].icon"
    ></axis-icon>
    @if (settings.heading === '') {
    <span
      class="axis-btn-icon-text _hidden-md-up"
      [innerHtml]="settings.label"
    ></span>
    } @else {
    <span
      class="axis-btn-icon-text"
      [innerHtml]="settings['showSelected'] === true ? settings['selected'].name || settings.heading : settings.heading || 'Custom Heading'"
    ></span>
    }
    }
    @if (headingDefault) {
    @if (settings['selected'] && settings['selected']['name']) {
    <span
      class="axis-btn-icon-text"
      [innerHtml]="settings['showSelected'] === true ? settings['selected'].name || settings.heading : settings.heading || 'Custom Heading'"
    ></span>
    } @else {
    @if (settingsDefault) {
    <span
      class="axis-btn-icon-text"
      [innerHtml]="settings['showSelected'] === true ? settings.heading || settings.placeholder : settings.heading"
    ></span>
    }
    }
    }
    @if (headingAvatar) {
    @if (settings["headingAvatar"]?.src) {
    <img
      [alt]="settings['headingAvatar']?.name"
      class="axis-img-responsive axis-img-circle {{settings['headingAvatar']?.size ? 'size-' + settings['headingAvatar']?.size : null}}"
      [src]="settings['headingAvatar']?.src"
    >
    } @else if (settings["headingAvatar"]?.initials) {
    <span
      class="axis-badge {{ settings['headingAvatar']?.color ? '_bg-' + settings['headingAvatar']?.color : null }} {{
            settings['headingAvatar']?.kind ? 'kind-' + settings['headingAvatar']?.kind : null
          }} {{ settings['headingAvatar']?.size ? 'size-' + settings['headingAvatar']?.size : null }}"
      [innerHtml]="settings['headingAvatar']?.initials"
    ></span>
    } @else {
    <span class="axis-badge _bg-steel-lightest {{
            settings['headingAvatar']?.kind ? 'kind-' + settings['headingAvatar']?.kind : null
          }} {{ settings['headingAvatar']?.size ? 'size-' + settings['headingAvatar']?.size : null }}"></span>
    }
    }
  </button>
  <div class="overlay"></div>
  @if (settings.closeOnOutsideClick && settings.menuVisible) {
  <div
    class="close-overlay"
    (click)="closeFlyout('click',$event)"
  ></div>
  }
  <div
    class="axis-menu"
    [class.show]="settings.menuVisible"
    [style.left.px]="settings.width==='full' ? menuLeft : null"
  >
    <div
      class="axis-menu-hoverable"
      (click)="settings.menuVisible=false"
      id="axis-menu-hoverable-{{settings.id}}"
    ></div>
    @if (menuCustom) {
    <div class="axis-mobile-close-btn">
      <button
        aria-label="Close menu"
        axis-button
        class="kind-icon"
        (click)="settings.menuVisible=false"
      >
        <axis-icon icon="x_large"></axis-icon>
      </button>
    </div>
    }
    <div
      class="axis-menu-custom axis-menu-content"
      #menuVar
    >
      <ng-template #menuContainer></ng-template>
      @if (!menuCustom) {
      <!--
          [attr.aria-hidden]="!settings.menuVisible"
-->
      <ul
        [attr.aria-activedescendant]="settings['items']['id']"
        [attr.aria-labelledby]="'label-' + settings.id"
        class="axis-menu-list"
        id="menu-{{settings.id}}"
        role="menu"
        [style.max-width.px]="settings.containerWidth"
        [style.min-width.px]="settings.containerWidth"
        [style.width.px]="settings.containerWidth"
      >
        <li class="axis-mobile-close-btn">
          <button
            axis-button
            class="kind-icon"
            (click)="settings.menuVisible=false"
          >
            <axis-icon icon="x_large"></axis-icon>
          </button>
        </li>
        @for (item of settings.items | orderBy:orderBy; track item.id; let i = $index) {
        <li
          [class]="item.itemClass"
          class="axis-menu-item"
          [class.axis-menu-item-border]="item.border"
          [class.axis-submenu]="item.subitemsCount>0"
        >
          @if (item.subitemsCount <
            1
            &&
            item.value
            !==''
            )
            {
            <a
            [attr.aria-selected]="settings['items']['id']===item.id"
            [class.selected]="settings.selected?.value === item.value && settings.showSelectedItem"
            (click)="selectOrShow(item, 1, $event)"
            data-flyout="option"
            class="axis-menu-text"
            href
            (keydown)="focusOption($event)"
            (keydown.space)="selectItem(item,$event)"
            (mouseenter)="mouseItem(item, 1, true)"
            (mouseleave)="mouseItem(item, 1, false, itemVar)"
            role="menuitem"
            tabindex="-1"
            #itemVar
          >
            <!--
                  (click)="selectItem(item,$event)"
                  (mouseenter)="item.hover=true"
                  (mouseleave)="itemVar.blur();item.hover=false"
-->
            @if (item.icon !== '') {
            <axis-icon
              class="{{item.size ? 'size-' + item.size : null}}"
              icon="{{item.selected ? item.iconSelected : item.icon}}"
            ></axis-icon>
            }
            @if (item.badgeHeading !== '') {
            <span
              class="axis-badge kind-circle size-medium {{item.badgeColor!=='' ? '_bg-' + item.badgeColor : null}}">{{item.badgeHeading}}</span>
            }
            @if (item.selected) {
            <span
              class="axis-menu-spacer"
              i18n="{{item.name}}@@{{settings.id}}-{{item.id}}id{{i}}"
              [innerHtml]="item.headingSelected || item.heading"
            ></span>
            } @else {
            <span
              class="axis-menu-spacer"
              i18n="{{item.name}}@@{{settings.id}}-{{item.id}}id{{i}}"
              [innerHtml]="item.heading"
            ></span>
            }
            @if (item.labelHeading !== '') {
            <span
              class="axis-label {{item.labelColor!=='' ? '_bg-' + item.labelColor : null}}">{{item.labelHeading}}</span>
            }
            @if (item.nested !== '') {
            <div
              i18n="{{item.nested}}@@{{settings.id}}-{{item.id}}id{{i}}"
              [innerHtml]="item.nested"
            ></div>
            }
            </a>
            }
            @if (item.value === '') {
            <span
              [attr.aria-label]="item.name + ' (Heading)'"
              class="axis-menu-item-heading axis-menu-text"
              [innerHtml]="item.name+item.id"
            ></span>
            }
            @if (item.subitemsCount > 0 && item.value !== '') {
            <a
              aria-expanded="item.flyoutVisible"
              aria-haspopup="true"
              [attr.aria-selected]="settings['items']['id']===item.id"
              [attr.data-index]="i"
              class="axis-menu-desktop axis-menu-text"
              (click)="selectOrShow(item, 2, $event)"
              data-flyout="option"
              href
              (keydown)="focusOption($event)"
              (keydown.arrowleft)="item.flyoutVisible=false"
              (keydown.arrowright)="item.flyoutVisible=true"
              (keydown.enter)="item.flyoutVisible=!item.flyoutVisible"
              (keydown.space)="item.flyoutVisible=!item.flyoutVisible"
              (keydown.escape)="item.flyoutVisible=false"
              (mouseenter)="mouseItem(item, 2, true)"
              (mouseleave)="mouseItem(item, 2, false)"
              role="menuitem"
              tabindex="-1"
            >
              @if (item.icon !== '') {
              <axis-icon
                class="{{item.size ? 'size-' + item.size : null}}"
                icon="{{item.icon}}"
              ></axis-icon>
              }
              @if (item.badgeHeading !== '') {
              <span
                class="axis-badge kind-circle size-medium {{item.badgeColor!=='' ? '_bg-' + item.badgeColor : null}}"
              >{{item.badgeHeading}}</span>
              }
              <span
                class="axis-menu-spacer"
                i18n="{{item.name}}@@{{settings.id}}-{{item.id}}id{{i}}"
                [innerHtml]="item.heading"
              ></span>
              @if (item.labelHeading !== '') {
              <span
                class="axis-label {{item.labelColor!=='' ? '_bg-' + item.labelColor : null}}">{{item.labelHeading}}</span>
              }
              @if (item.nested !== '') {
              <div
                i18n="{{item.nested}}@@{{settings.id}}-{{item.id}}id{{i}}"
                [innerHtml]="item.nested"
              ></div>
              }
              <!--
                    [attr.aria-hidden]="!item.flyoutVisible"
                    -->
              <ul
                [attr.aria-labelledby]="'button-' + settings.id"
                class="axis-menu {{settings['columnsSubitems']>1 ? 'column-' + settings['columnsSubitems'] : null}}"
                [class.axis-column]="settings['columnsSubitems']>1 ? true : null"
                [class.scroll]="settings['scrollSubitems']"
                [class.show]="item.flyoutVisible"
                (mouseenter)="mouseItem(item, 3, true)"
                (mouseleave)="mouseItem(item, 3, false)"
                role="menu"
              >
                @for (subitem of item.subitems | orderBy:orderBy; track subitem.id) {
                <li
                  [class]="subitem.subitemClass"
                  class="axis-menu-item"
                >
                  <a
                    [class.selected]="settings.selected?.value === subitem.value && settings.showSelectedItem"
                    class="axis-menu-text"
                    (click)="selectItem(subitem,$event)"
                    data-flyout="suboption"
                    href
                    (keydown)="focusOption($event)"
                    (keydown.enter)="selectItem(subitem,$event)"
                    (keydown.space)="selectItem(subitem,$event)"
                    role="menuitem"
                  >
                    <span
                      i18n="{{subitem}}@@{{settings.id}}-{{item.id}}id{{i}}"
                      class="axis-df-subitem"
                      [innerHtml]="subitem['name']"
                    ></span>
                  </a>
                </li>
                }
              </ul>
            </a>
            <a
              aria-expanded="item.flyoutVisible"
              aria-haspopup="true"
              [attr.aria-selected]="settings['items']['id']===item.id"
              [attr.data-index]="i"
              class="axis-menu-mobile axis-menu-text"
              (click)="item.flyoutVisible=!item.flyoutVisible"
              href
              role="menuitem"
              tabindex="-1"
            >
              @if (item.icon !== '') {
              <axis-icon
                class="{{item.size ? 'size-' + item.size : null}}"
                icon="{{item.icon}}"
              ></axis-icon>
              }
              <span
                i18n="{{item.name}}@@{{settings.id}}-{{item.id}}id{{i}}"
                class="axis-menu-spacer"
                [innerHtml]="item.heading"
              ></span>
              @if (item.labelHeading !== '') {
              <span
                class="axis-label {{item.labelColor!=='' ? '_bg-' + item.labelColor : null}}">{{item.labelHeading}}</span>
              }
              @if (item.nested !== '') {
              <div
                i18n="{{item.nested}}@@{{settings.id}}-{{item.id}}id{{i}}"
                [innerHtml]="item.nested"
              ></div>
              }
              <!--
                    [attr.aria-hidden]="!item.flyoutVisible"
                    -->
              <ul
                [attr.aria-labelledby]="'button-' + settings.id"
                class="axis-menu"
                [class.show]="item.flyoutVisible"
                role="menu"
              >
                <li class="axis-mobile-close-btn">
                  <button
                    axis-button
                    class="kind-icon"
                  >
                    <axis-icon icon="x_large"></axis-icon>
                  </button>
                </li>
                @for (subitem of item.subitems | orderBy:orderBy; track subitem.id) {
                <li
                  [class]="subitem.subitemClass"
                  class="axis-menu-item"
                >
                  <a
                    (click)="selectItem(subitem)"
                    [class.selected]="settings.selected?.value === subitem.value && settings.showSelectedItem"
                    class="axis-menu-text"
                    href
                    role="menuitem"
                  >
                    <span
                      i18n="{{subitem}}@@{{settings.id}}-{{item.id}}id{{i}}"
                      class="axis-df-subitem"
                      [innerHtml]="subitem['name']"
                    ></span>
                  </a>
                </li>
                }
              </ul>
            </a>
            }
        </li>
        }
      </ul>
      }
    </div>
  </div>
</div>